export const FlashcardsPracticeTranslations = {
  TRANSCRIBED_SUCCESSFULLY: {
    es: 'Transcripción realizada correctamente',
    en: 'Transcription done successfully',
    cat: 'Transcripció realitzada correctament',
    eus: 'Erantzun transkribatu ongi',
    pt: 'Transcrição de resposta realizada com sucesso'
  },
  TRANSCRIPTION_FAILED: {
    es: 'Error al transcribir la respuesta',
    en: 'Error transcribing the answer',
    cat: 'Error al transcriure la resposta',
    eus: 'Erantzun transkribatuaren errorea',
    pt: 'Erro ao transcrever a resposta'
  },
  DONT_KNOW: {
    es: 'No lo sé',
    en: "I don't know",
    cat: 'No sé',
    eus: 'Ez dakit',
    pt: 'Não sei'
  },
  KNOW_SOME: {
    es: 'Falta repaso',
    en: 'Need to review',
    cat: 'Cal falta repassar',
    eus: 'Ez dakit',
    pt: 'Precisa revisar'
  },
  KNOW_ALL: {
    es: 'Lo sé',
    en: 'I know',
    cat: 'Sé',
    eus: 'Ez dakit',
    pt: 'Sei'
  },
  NOT_PRACTICED: {
    es: 'No practicada',
    en: 'Not practiced',
    cat: 'No practicada',
    eus: 'Ezabatu nahi duzu',
    pt: 'Não praticada'
  },
  WRITE_YOUR_ANSWER: {
    es: 'Escribe tu respuesta',
    en: 'Write your answer',
    cat: 'Escriu la teva resposta',
    eus: 'Erantzun zurek',
    pt: 'Escreva a sua resposta'
  },
  ERROR_TRANSCRIPTION: {
    es: 'Error en la transcripción',
    en: 'Error in transcription',
    cat: 'Error en la transcripción',
    eus: 'Transkripzio-errorea',
    pt: 'Erro na transcrição'
  },
  PRESS_TO_STOP_RECORDING: {
    es: 'Presiona para detener la grabación',
    en: 'Press to stop recording',
    cat: 'Preme per aturar la gravació',
    eus: 'Ezabatu nahi duzu',
    pt: 'Pressione para parar de gravar'
  },
  CONVERTING_TO_TEXT: {
    es: 'Convirtiendo a texto...',
    en: 'Converting to text...',
    cat: 'Convertint a text...',
    eus: 'Testura bihurtzen...',
    pt: 'Convertendo para texto...'
  },
  SHOW_ANSWER: {
    es: 'Mostrar respuesta',
    en: 'Show answer',
    cat: 'Mostrar resposta',
    eus: 'Erakutsi erantzun',
    pt: 'Mostrar resposta'
  },
  CORRECT_ANSWER: {
    es: 'Respuesta correcta',
    en: 'Correct answer',
    cat: 'Resposta correcta',
    eus: 'Erantzun zuzena',
    pt: 'Resposta correta'
  },
  YOUR_ANSWER: {
    es: 'Tu respuesta',
    en: 'Your answer',
    cat: 'La teva resposta',
    eus: 'Erantzun zurek',
    pt: 'A sua resposta'
  },
  CONTROL_FLASHCARD_VISIBILITY_MODAL_TITLE: {
    es: 'No es posible ocultar esta flashcard',
    en: 'It is not possible to hide this flashcard',
    cat: 'No és possible ocultar aquesta targeta',
    eus: 'Ezin da hori flashkarta ezkutatu',
    pt: 'Não é possível ocultar esta flashcard'
  },
  CONTROL_FLASHCARD_VISIBILITY_MODAL_CONTENT: {
    es: 'Esta es la última flashcard visible de la colección. Siempre debe quedar al menos una visible durante la práctica.',
    en: 'This is the last visible flashcard in the collection. It must always leave at least one visible during the practice.',
    cat: 'Aquesta és la darrera targeta visible de la col·lecció. Sempre ha de quedar almenys una visible durant la pràctica.',
    eus: 'Hori flashkarta hau azkenezik dagoen bilduma-bikotean azkenezik dago. Ezin da beti ezkutatu.',
    pt: 'Esta é a última flashcard visível da colecção. Sempre deve deixar pelo menos uma visível durante a prática.'
  },
  CONTROL_FLASHCARD_VISIBILITY_MODAL_CANCEL_TEXT: {
    es: 'Entendido',
    en: 'Understood',
    cat: 'Entés',
    eus: 'Ezabatu nahi duzu',
    pt: 'Entendido'
  },
  CONFIGURATION: {
    es: 'Configuración',
    en: 'Configuration',
    cat: 'Configuració',
    eus: 'Konfigurazioa',
    pt: 'Configuração'
  },
  FLASHCARD_STUDY_STATUS: {
    es: 'Estado del estudio',
    en: 'Study status',
    cat: 'Estat del estudi',
    eus: 'Ikastudia-egoera',
    pt: 'Estado do estudo'
  },
  SELECT_THE_STATUS: {
    es: 'Selecciona el estado',
    en: 'Select the status',
    cat: "Selecciona l'estat",
    eus: 'Estatua aukeratu',
    pt: 'Selecione o estado'
  },
  RESET_FILTERS: {
    es: 'Reiniciar filtros',
    en: 'Reset filters',
    cat: 'Reiniciar filtres',
    eus: 'Iragazkiak berrezarri',
    pt: 'Reiniciar filtros'
  },
  NO_FLASHCARDS_FOUND: {
    es: 'No se encontraron flashcards',
    en: 'No flashcards found',
    cat: 'No targetes de flashcards',
    eus: 'Ez da flashcardrik aurkitu',
    pt: 'Não foram encontradas flashcards'
  },
  NO_FLASHCARDS_FOUND_DESCRIPTION: {
    es: 'Esta colección no tiene flashcards que coincidan con los filtros seleccionados.',
    en: 'This collection does not have flashcards that match the selected filters.',
    cat: 'Aquesta col·lecció no té targetes de flashcards que coincideixin amb els filtres seleccionats.',
    eus: 'Bilduma honek ez du hautatutako iragazkiekin bat datozen flashcard-ik',
    pt: 'Não foram encontradas flashcards que coincidam com os filtros selecionados.'
  },
  YOU_KNOW_ALL_COLLECTION: {
    es: '¡Te sabes toda la colección!',
    en: 'You know all the collection!',
    cat: 'Saps tots els conjunts!',
    eus: 'Ez dakit bilduma guztira!',
    pt: 'Você sabe todos os conjuntos!'
  },
  YOU_KNOW_ALL_COLLECTION_DESCRIPTION: {
    es: 'Estás llevando tu aprendizaje al siguiente nivel. ¡Continúa dándole caña!',
    en: 'You are taking your learning to the next level. Keep up the good work!',
    cat: 'Estàs portant el teu estudi al següent nivell. Continúa donant-li força!',
    eus: 'Zure ikaskuntza hurrengo mailara eramaten ari zara. Jarraitu!',
    pt: 'Você está levando seu aprendizado para o próximo nível. Continue dando caña!'
  },
  BACK_TO_START: {
    es: 'Volver al inicio',
    en: 'Back to start',
    cat: "Tornar a l'inici",
    eus: 'Itzuli hasierara',
    pt: 'Voltar para o início'
  },
  SHOW_COLLECTIONS: {
    es: 'Ver colecciones',
    en: 'Show collections',
    cat: 'Mostra col·leccions',
    eus: 'Erakutsi bildumak',
    pt: 'Ver coleções'
  },
  FLASHCARD_TRANSCRIBE_LANGUAGE: {
    es: 'Idioma de la transcripción',
    en: 'Language of transcription',
    cat: 'Idioma de la transcripció',
    eus: 'Ikastudia-egoera',
    pt: 'Idioma da transcrição'
  },
  SPANISH: {
    es: 'Español',
    en: 'Spanish',
    cat: 'Espanyol',
    eus: 'Gaztelania',
    pt: 'Espanhol'
  },
  ENGLISH: {
    es: 'Inglés',
    en: 'English',
    cat: 'Anglès',
    eus: 'Ingelesa',
    pt: 'Inglês'
  },
  CATALAN: {
    es: 'Catalán',
    en: 'Catalan',
    cat: 'Català',
    eus: 'Katalana',
    pt: 'Catalão'
  },
  PORTUGUESE: {
    es: 'Portugués',
    en: 'Portuguese',
    cat: 'Portuguès',
    eus: 'Portugalska',
    pt: 'Português'
  },
  SELECT_LANGUAGE: {
    es: 'Selecciona un idioma',
    en: 'Select a language',
    cat: 'Alegeix un idioma',
    eus: 'Hautatu hizkuntza',
    pt: 'Selecione um idioma'
  }
};
